// extracted by mini-css-extract-plugin
export default {"imageWrapper":"pH-z","videoWrapper":"qH-z","twoColumnImage":"rH-z","imageCarouselBtn":"sH-z","carouselNextBtn":"tH-z","carouselPrevBtn":"uH-z"};